"use client";

import { queryOptions } from "@tanstack/react-query";
import { Map } from "immutable";
import { Organization } from "@/interfaces/organization";

export const organizationsSearchOptions = (
  query: string,
  stateIds?: string[],
  countyIds?: string[],
  cityIds?: string[],
  channelTypeIds?: string[],
) => {
  return queryOptions({
    queryKey: [
      "organizations",
      { query, stateIds, countyIds, cityIds, channelTypeIds },
    ],
    queryFn: async () => {
      const hasSearchTerm = query && query.trim().length >= 2;

      const searchParams = new URLSearchParams();
      if (stateIds && stateIds.length > 0) {
        stateIds.forEach((id) => searchParams.append("stateId", id));
      }
      if (countyIds && countyIds.length > 0) {
        countyIds.forEach((id) => searchParams.append("countyId", id));
      }
      if (cityIds && cityIds.length > 0) {
        cityIds.forEach((id) => searchParams.append("cityId", id));
      }
      if (channelTypeIds && channelTypeIds.length > 0) {
        channelTypeIds.forEach((id) =>
          searchParams.append("channelTypeId", id),
        );
      }

      if (searchParams.toString().length < 1 && !hasSearchTerm) {
        return [];
      }
      if (hasSearchTerm) {
        searchParams.set("q", query);
      }

      const response = await fetch(`/api/organizations?${searchParams}`);

      if (!response.ok) {
        throw new Error("Failed to fetch organizations");
      }

      const data: Organization[] = await response.json();
      return data;
    },
    enabled:
      query.trim().length >= 2 ||
      (stateIds && stateIds.length > 0) ||
      (countyIds && countyIds.length > 0) ||
      (cityIds && cityIds.length > 0) ||
      (channelTypeIds && channelTypeIds.length > 0),
  });
};

export const organizationsMapOptions = () => {
  return queryOptions<
    Map<number, Organization>,
    Error,
    Map<number, Organization>,
    [string]
  >({
    queryKey: ["organizations"],
    queryFn: () => Map(),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: false,
  });
};
